import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

// Only initialize Sentry in production environment
const isProduction = process.env.NODE_ENV === "production";

if (isProduction) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],

    tracesSampleRate: 1.0, // Capture 100% of transactions
    tracePropagationTargets: [
      /^\//, // All internal paths
      /^https:\/\/app\.test\.trilodocs\.com\/api/,
    ],

    // Session Replay Configuration
    replaysSessionSampleRate: 0.1, // Sample 10% of sessions
    replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions with errors
  });
}

export const setSentryUser = auth0User => {
  // Only set user in production environment
  if (isProduction && auth0User) {
    Sentry.setUser({
      id: auth0User.sub,
      email: auth0User.email,
      username: auth0User.nickname || auth0User.name,
      metadata: {
        auth0_updated_at: auth0User.updated_at,
        email_verified: auth0User.email_verified,
        locale: auth0User.locale,
      },
    });
  }
};
